import React from "react";
import {
  // FaTwitter,
  FaLinkedinIn,
  FaGithub,
} from "react-icons/fa";

const SocialShare = [
  { Social: <FaLinkedinIn />, link: "https://www.linkedin.com/in/laurasimsdev" },
  { Social: <FaGithub />, link: "https://www.github.com/laurasimsdev" },
  // { Social: <FaTwitter />, link: "https://twitter.com/laurasimsdev" },
];

const Social = () => {
  return (
    <div className="nav social-icons justify-content-center">
      {SocialShare.map((val, i) => (
        <a key={i} href={`${val.link}`} rel="noreferrer" target="_blank">
          {val.Social}
        </a>
      ))}
    </div>
  );
};

export default Social;
